import { render, staticRenderFns } from "./manufacture.vue?vue&type=template&id=6732e6bf&scoped=true&"
import script from "./manufacture.vue?vue&type=script&lang=js&"
export * from "./manufacture.vue?vue&type=script&lang=js&"
import style0 from "./manufacture.vue?vue&type=style&index=0&id=6732e6bf&lang=scss&scoped=true&"
import style1 from "./manufacture.vue?vue&type=style&index=1&id=6732e6bf&lang=scss&scoped=true&"
import style2 from "./manufacture.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6732e6bf",
  null
  
)

export default component.exports